import {
  Paper,
  Stack,
  Box,
  Typography,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  IconButton
} from '@mui/material';
import { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { formatearFechaLocal, normalizarFechaISO } from '../../utils/horaLocal';
import { ModalArqueoCaja } from './ModalesInventario';
import { v4 as uuid } from 'uuid';

export default function ArqueoCaja({ state, gastos }) {
  const [abrirFormulario, setAbrirFormulario] = useState(false);
  const [historico, setHistorico] = useState(state.arqueos || []);

  const formatearMonto = (monto) => {
    return new Intl.NumberFormat('es-BO', {
      style: 'currency',
      currency: 'BOB'
    }).format(monto);
  };

  const handleRegistrarArqueo = async (nuevoArqueo) => {
    const created = await state.guardarArqueo(nuevoArqueo);
    const savedArqueo = created || nuevoArqueo;
    setHistorico(prev => [...prev, savedArqueo]);
    return savedArqueo;
  };

  const handleRegistrarAjuste = async (nuevoAjuste) => {
    await state.guardarAjuste(nuevoAjuste);
    setAbrirFormulario(false);
  };

  const handleAnularArqueo = async (id) => {
    if (!window.confirm('¿Anular este arqueo?')) return;
    await state.anularArqueo(id);
    await state.anularAjustesPorArqueo(id);
    setHistorico(prev => prev.map(a => a.id === id ? { ...a, anulado: true } : a));
  };

  const handleAnularArqueoDelModal = async (id) => {
    await state.anularArqueo(id);
    await state.anularAjustesPorArqueo(id);
    setHistorico(prev => prev.map(a => a.id === id ? { ...a, anulado: true } : a));
    setAbrirFormulario(false);
  };

  return (
    <Stack spacing={3}>
      <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <Box>
            <Typography variant="h4" fontWeight="bold">
              Arqueo de Caja
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Registro de cortes físicos
            </Typography>
          </Box>

          <Button
            variant="contained"
            color="primary"
            onClick={() => setAbrirFormulario(true)}
          >
            + Nuevo Arqueo
          </Button>
        </Stack>
      </Paper>

      {/* MODAL ARQUEO CENTRALIZADO */}
      <ModalArqueoCaja
        open={abrirFormulario}
        onClose={() => setAbrirFormulario(false)}
        state={{ ...state }}
        díaBloqueado={false}
        onRegistrarArqueo={handleRegistrarArqueo}
        onRegistrarAjuste={handleRegistrarAjuste}
        onAnularArqueo={handleAnularArqueoDelModal}
      />

      {/* HISTORIAL DE ARQUEOS */}
      <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
        <Typography variant="h6" fontWeight="bold" mb={2}>
          Historial de Arqueos
        </Typography>

        <Box sx={{ overflowX: 'auto' }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: '#f8f9fa' }}>
                <TableCell>Fecha</TableCell>
                <TableCell align="right">Saldo Teórico</TableCell>
                <TableCell align="right">Total Contado</TableCell>
                <TableCell align="right">Diferencia</TableCell>
                <TableCell align="center">Estado</TableCell>
                <TableCell align="center">Acción</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {historico.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <Typography variant="body2" color="textSecondary" sx={{ p: 2 }}>
                      Sin arqueos registrados
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                historico.map(a => (
                  <TableRow key={a.id} sx={{ opacity: a.anulado ? 0.4 : 1 }}>
                    <TableCell>{formatearFechaLocal(normalizarFechaISO(a.fecha))}</TableCell>
                    <TableCell align="right">{formatearMonto(a.saldoTeorico)}</TableCell>
                    <TableCell align="right">{formatearMonto(a.totalContado)}</TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        fontWeight: 'bold',
                        color:
                          a.diferencia === 0
                            ? '#2e7d32'
                            : a.diferencia > 0
                            ? '#f57f17'
                            : '#d84315'
                      }}
                    >
                      {formatearMonto(a.diferencia)}
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        label={a.estado}
                        color={
                          a.estado === 'CORRECTO'
                            ? 'success'
                            : a.estado === 'SOBRANTE'
                            ? 'warning'
                            : 'error'
                        }
                        size="small"
                      />
                      {a.anulado && <Chip label="ANULADO" size="small" sx={{ ml: 1 }} />}
                    </TableCell>
                    <TableCell align="center">
                      {!a.anulado && (
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => handleAnularArqueo(a.id)}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </Box>
      </Paper>
    </Stack>
  );
}
